import client from "../apollo/apolloClient";
import ApolloTags from "../apollo/apolloTag";
import API from "../axios";
import CONSTANTS from "../const/constants";

export const createTag = async (name, color, companyId, key, spaceId = null) => {
  try {
    // Si es la compañía específica y tiene spaceId, usar la mutación con spaceId
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID && spaceId) {
      const response = await client.mutate({
        mutation: ApolloTags.CREATE_TAG_WITH_SPACE,
        variables: { name, color, companyId, key, companyIdString: companyId, spaceId },
      });
      return response.data.createTag;
    }
    
    // Comportamiento original para otras compañías
    const response = await client.mutate({
      mutation: ApolloTags.CREATE_TAG,
      variables: { name, color, companyId, key, companyIdString: companyId },
    });
    return response.data.createTag;
  } catch (error) {
    if (error.message.includes("Details: Field name = key"))
      throw new Error("ERROR_CREATING_TAG_DUPLICATED");
    throw new Error("ERROR_CREATING_TAG");
  }
};

export const getTags = async (companyId, spaceId = null) => {
  try {
    // Si es la compañía específica y tiene spaceId, usar la query filtrada por spaceId
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID && spaceId) {
      const response = await client.query({
        query: ApolloTags.GET_TAGS_BY_SPACE,
        variables: { companyId, spaceId },
        fetchPolicy: 'network-only',
      });
      console.log("RESPONSE TAG BY SPACE: ", response.data);
      return response.data;
    }
    
    // Comportamiento original para otras compañías
    const response = await client.query({
      query: ApolloTags.GET_TAGS,
      variables: { companyId },
    });
    console.log("RES¨PONSETAG: ",response.data);
    return response.data;
  } catch (error) {
    throw new Error("ERROR_GETTING_TAGS");
  }
};

export const getTagBotConfigs = async () => {
  try {
    const response = await API.get("/disable-bot-tags");
    return response?.data?.tagsForDisable;
  } catch (error) {
    console.error("Error in getTagBotConfigs:", error);
    return { data: [] };
  }
};

export const getNotDefaultTags = async (companyId, spaceId = null) => {
  try {
    // Si es la compañía específica y tiene spaceId, usar la query filtrada por spaceId
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID && spaceId) {
      const response = await client.query({
        query: ApolloTags.GET_NOT_DEFAULT_TAGS_BY_SPACE,
        variables: { companyId, spaceId },
        fetchPolicy: 'network-only',
      });
      return response.data;
    }
    
    // Comportamiento original para otras compañías
    const response = await client.query({
      query: ApolloTags.GET_NOT_DEFAULT_TAGS,
      variables: { companyId },
    });
    return response.data;
  } catch (error) {
    throw new Error("ERROR_GETTING_TAGS");
  }
};

export const deleteTag = async (id) => {
  try {
    const response = await client.mutate({
      mutation: ApolloTags.DELETE_TAG,
      variables: { id },
    });
    return response.data.deleteTag;
  } catch (error) {
    throw new Error("ERROR_DELETING_TAG");
  }
};

export const editTag = async (id, name, color, key) => {
  try {
    const response = await client.mutate({
      mutation: ApolloTags.EDIT_TAG,
      variables: { id, name, color, key },
    });
    return response.data.updateTag;
  } catch (error) {
    if (error.message.includes("Details: Field name = key"))
      throw new Error("ERROR_CREATING_TAG_DUPLICATED");
    throw new Error("ERROR_UPDATING_TAG");
  }
};

export const upsertTag = async (name, color, companyId, key, spaceId = null) => {
  try {
    // Si es la compañía específica y tiene spaceId, usar la mutación con spaceId
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID && spaceId) {
      const response = await client.mutate({
        mutation: ApolloTags.UPSERT_TAG_WITH_SPACE,
        variables: { name, color, companyId, key, companyIdString: companyId, spaceId },
      });
      return response.data.upsertTag;
    }
    
    // Comportamiento original para otras compañías
    const response = await client.mutate({
      mutation: ApolloTags.UPSERT_TAG,
      variables: { name, color, companyId, key, companyIdString: companyId },
    });
    return response.data.upsertTag;
  } catch (error) {
    if (error.message.includes("Details: Field name = key"))
      throw new Error("ERROR_CREATING_TAG_DUPLICATED");
    throw new Error("ERROR_UPSERT_TAG");
  }
};

export const getTagsCount = async (channelId, companyId) => {
  try {
    const body = {};
    if (channelId) body.channelId = channelId;
    if (companyId) body.companyId = companyId;
    const response = await API.post("/tagsCountMongo", body);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export default createTag;
